import { withInstall, withNoopInstall } from '@sgui-plus/utils'
import Anchor from './src/anchor.vue'
import AnchorLink from './src/anchor-link.vue'

export const SgAnchor = withInstall(Anchor, {
  AnchorLink
})
export default SgAnchor

export const SgAnchorLink = withNoopInstall(AnchorLink)

export * from './src/anchor'
export * from './src/anchor-link'
export * from './src/constants'
